import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ModalUploadPluginComponent } from './modal-upload/modal-upload.component';
import { ModalMultiuploadPluginComponent } from './modal-multi-upload/modal-multi-upload.component';

@Component({
    selector: 'app-upload-plugin',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.css']
})
export class UploadPluginComponent {

    @Input() horizontal;
    @Input() aspectRatio;
    @Input() resizeToWidth;
    @Input() type;
    @Input() multiple;
    @Input() onlyType;
    @Output() AddPhoto: EventEmitter<any> = new EventEmitter<any>();
    @Output() AddArchive: EventEmitter<any> = new EventEmitter<any>();
    @Input() btnClass = 'btn btn-default btn-xs';
    @Input() btnTitle = 'ADICIONAR ARQUIVO';

    constructor(
        public dialog: MatDialog
    ) {

    }

    openDialog(): void {
        if (this.multiple) {
            const dialogRef = this.dialog.open(ModalMultiuploadPluginComponent, {
                width: '800px',
                height: '450px',
                disableClose: true,
                data: {
                    type: this.type,
                    resizeToWidth: this.resizeToWidth,
                    aspectRatio: this.aspectRatio,
                    horizontal: this.horizontal,
                    multiple: this.multiple,
                    onlyType: this.onlyType
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    if (this.type === 'image') {
                        this.AddPhoto.emit(result);
                    } else {
                        this.AddArchive.emit(result);
                    }
                }
            });
        } else {
            const dialogRef = this.dialog.open(ModalUploadPluginComponent, {
                width: '800px',
                height: '450px',
                disableClose: true,
                data: {
                    type: this.type,
                    resizeToWidth: this.resizeToWidth,
                    aspectRatio: this.aspectRatio,
                    horizontal: this.horizontal,
                    multiple: this.multiple,
                    onlyType: this.onlyType
                }
            });

            dialogRef.afterClosed().subscribe(result => {

                console.log(this.type);
                console.log(result);
                console.log('upload');

                if (result) {
                    if (this.type === 'image') {
                        this.AddPhoto.emit(result);
                    } else {
                        this.AddArchive.emit(result);
                    }
                }
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/upload/upload.component.ts